import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { themes } from '../../themes';
import { themeUISelectors } from '../../store/UI/theme.slice';
import {platformSelectors} from "@clatter/platform";

const AppThemeProvider = ({ children }) => {
  const selectedTheme = useSelector(themeUISelectors.getSelectedTheme)?.value;
  const toolInfoPrimaryColor = useSelector(platformSelectors.toolInfo.selectToolInfo)?.data?.color?.primaryColor;

  let theme = themes[selectedTheme]

  if (toolInfoPrimaryColor) {
    theme.palette.primaryColor = toolInfoPrimaryColor;
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppThemeProvider;
